/**
 * The reaction palette for project messages.
 *
 * An ALLOWLIST, not free text. Two reasons: it keeps the reaction bar bounded
 * (six columns, no horizontal scroll, no per-message layout surprise), and it
 * means the emoji string is never attacker-controlled text that both clients
 * would have to render.
 */
export const MESSAGE_REACTION_EMOJI = ['👍', '❤️', '😂', '🎉', '👀', '✅'];
export function isMessageReactionEmoji(value) {
    return MESSAGE_REACTION_EMOJI.includes(value);
}
/** The handle that notifies everyone who can see the project. Reserved in
 *  RESERVED_USERNAMES (and enforced by a DB trigger), so no user can hold it. */
export const MENTION_ALL_HANDLE = 'all';
/** Max messages a single poll delta will return. Past this the response is a
 *  prefix and `truncated` is set, which tells the client to refetch rather than
 *  advance its cursor over a gap. */
export const PROJECT_MESSAGE_POLL_LIMIT = 200;
/** Poll interval while the Messages tab is open. */
export const PROJECT_MESSAGE_POLL_MS = 10_000;
/** Messages per page of transcript history. */
export const PROJECT_MESSAGE_PAGE_SIZE = 50;
//# sourceMappingURL=message-reactions.js.map